import { defineComponent as _defineComponent } from 'vue'
import AuthenticatingComponent from "@/components/authenticating.component.vue";
import InstallUpdateComponent from "@/components/dialogs/install-update-dialog.vue";
import PopupDialog from "@/components/dialogs/popup-dialog.vue";
import { onMounted, ref } from "vue";
import { useRoute } from "vue-router/composables";
import { useManageAppUpdates } from "./composables/use-manage-app-updates";
// @ts-ignore
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const isStagingEnv = process.env.VUE_APP_IS_STAGING;
const APP_VERSION = process.env.VUE_APP_VERSION;
const isDev = process.env.NODE_ENV !== "production";

const route = useRoute();

const index = ref<number | null>(null);
const items = [
  "https://victoria-university-elearning.s3.us-east-1.amazonaws.com/general_resources/rajiv-legacy.webp",
];

const { installUpdateDialogVisible, reloadPage } = useManageAppUpdates();
const showPopupDialog = ref(false);
const appVersion = isDev ? "Development" : `Version 3.${APP_VERSION}`;

const popupDialogTitle = ref("📢 Welcome Back, Students! 📢");
const popupDialogContent = ref(`
              <div>
                  We hope you had a restful and refreshing break! As we begin the <span style="font-weight: 500">March 2025 Trimester</span>, we are excited to welcome both returning and new students to another enriching academic journey. Please take note of the important dates for the trimester below:


                    <table style="width: 100%; border-collapse: collapse; margin-top: 20px">
                          <tr>
                              <th style="border: 1px solid black; padding: 8px; background-color: #f2f2f2; text-align: left;">March Trimester</th>
                              <th style="border: 1px solid black; padding: 8px; background-color: #f2f2f2; text-align: left;">Teaching Dates</th>
                              <th style="border: 1px solid black; padding: 8px; background-color: #f2f2f2; text-align: left;">Exam Dates</th>
                          </tr>
                          <tr>
                              <td style="border: 1px solid black; padding: 8px; font-weight: 500">New Student Induction</td>
                              <td style="border: 1px solid black; padding: 8px;">19th to 21st March 2025</td>
                              <td style="border: 1px solid black; padding: 8px;"></td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid black; padding: 8px; font-weight: 500">Teaching Block 1</td>
                              <td style="border: 1px solid black; padding: 8px;">24th March to 24th April 2025</td>
                              <td style="border: 1px solid black; padding: 8px;">25th and 26th April</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid black; padding: 8px; font-weight: 500;">Teaching Block 2</td>
                              <td style="border: 1px solid black; padding: 8px;">28th April to 29th May 2025</td>
                              <td style="border: 1px solid black; padding: 8px;">30th and 31st May</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid black; padding: 8px; font-weight: 500">Teaching Block 3</td>
                              <td style="border: 1px solid black; padding: 8px;">2nd June to 3rd July 2025</td>
                              <td style="border: 1px solid black; padding: 8px;">4th and 5th July</td>
                          </tr>
                          <tr>
                              <td style="border: 1px solid black; padding: 8px; font-weight: 500">Holiday</td>
                              <td style="border: 1px solid black; padding: 8px;">6th to 20th July 2025</td>
                              <td style="border: 1px solid black; padding: 8px;"></td>
                          </tr>
                      </table>

                      <div style="margin-top: 25px">
                        We encourage you to plan ahead and make the most of this trimester. Wishing you all a successful and productive academic term!

                        </div>

                </div>`);

const openPopupDialog = () => {
  showPopupDialog.value = true;
};
const closePopupDialog = () => {
  showPopupDialog.value = false;

  // setTimeout(() => {
  //   if (
  //     popupDialogTitle.value ===
  //     "📢 IMPORTANT DATES FOR MARCH TRIMESTER 2024 📢"
  //   ) {
  //     popupDialogTitle.value = "📢 COLLECTION OF IDENTITY CARDS 📢";
  //     popupDialogContent.value = `

  //         <div>
  //             <div class="mt-2">
  //               Dear students,
  //             </div>
  //             <div class="mt-1">
  //               We are pleased to inform you that the identity cards for students of March 2023, July 2023, November 2023, and March 2024 intakes are now available for collection. If you have already provided your passport photos, please visit the Admissions Office at your earliest convenience to collect your ID card.
  //             </div>
  //             <div class="mt-2">
  //               For those in the March 2024 intake who have not yet submitted their passport photos, it is essential to do so promptly to avoid any delays in receiving your identity card. Kindly come to the Admissions Office to have your photo taken and complete this requirement.
  //             </div>
  //             <div class="mt-2">
  //               Thank you.
  //             </div>

  //           </div>`;

  //     showPopupDialog.value = true;
  //   }
  // }, 1000);
};

onMounted(() => {
  // Show CoolLightBox on load
  if (process.env.VUE_APP_NO_COOL_LIGHT_BOX_POPUP != "true") {
    setTimeout(() => {
      index.value = 0;
    }, 1000);
  }

  if (route.name != "OngoingCourseWork" && route.name != "OngoingExamination") {
    if (!process.env.VUE_APP_NO_STUDENT_POPUP_DIALOG) {
      // Wait 3 seconds and show popup dialog
      setTimeout(() => {
        openPopupDialog();
      }, 3000);
    }
  }
});

return { __sfc: true,isStagingEnv, APP_VERSION, isDev, route, index, items, installUpdateDialogVisible, reloadPage, showPopupDialog, appVersion, popupDialogTitle, popupDialogContent, openPopupDialog, closePopupDialog, AuthenticatingComponent, InstallUpdateComponent, PopupDialog, CoolLightBox, store }
}

})